import React from 'react';
import { NotificationSVG } from '../../../img/GlobalSVG';
import './ToastMessage.scss';

const ToastMessage = ({
  type = '', //Types: warning | success | error | info
  title = '',
  subTitle = '',
}) => {
  return (
    <div className="d-flex toast-box ml-2 align-items-start">
      {type === 'success' ? (
        <NotificationSVG.CheckMarkSVG />
      ) : type === 'error' ? (
        <NotificationSVG.ExclamationErrorSVG />
      ) : type === 'warning' ? (
        <NotificationSVG.WarningSVG />
      ) : (
        <NotificationSVG.InformativeSVG />
      )}

      <div className="message-body ml-3">
        {title && <h3 className={`${subTitle && 'mb-1 '}`}>{title}</h3>}
        {subTitle && <p className={`${!title && 'font-14'}`}>{subTitle}</p>}
      </div>
    </div>
  );
};

export default ToastMessage;
